import { FormControl, RadioGroup, FormControlLabel, Radio } from '@material-ui/core';

function YesNoRadio({ value, onChange, options = [] }) {
  return (
    <FormControl component="fieldset">
      <RadioGroup aria-label="gender" row name="gender" value={value} onChange={onChange}>
        {options.map((option, index) => (
          <FormControlLabel
            value={option.value}
            control={<Radio color="primary" />}
            label={option.label}
            labelPlacement="end"
            key={index}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}

export default YesNoRadio;
